import { EnvVariables } from 'src/types/model';

import { useRouteContext } from './useRouteContext';

export const useEnvVariables = (): EnvVariables => {
  const { routeData } = useRouteContext();
  return (
    routeData?.envVars || {
      resizeImages: '',
      turnstileSiteKey: '',
      pdfBaseUrl: '',
      pdfBaseUrlEastasia: '',
      pdfPrintServerUrl: '',
    }
  );
};
